import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyVideoBackgroundMonogramLayout = loadable(
  () => import(/* webpackChunkName: "content/guest/header/videoBackgroundMonogram" */ './VideoBackgroundMonogram'),
  'VideoBackgroundMonogramLayout',
);
